import Layout from "../layout";
import DataTracking from "./_components/DataTracking";

export default function Tracking() {
    return (
        <Layout>
            <DataTracking />
        </Layout>
    );
}